import SafaricomOTPService from '@/services/SafaricomOTPService'

const state = {
    otpToken: null,
    otp: null,
    guid: null,
    timestamp: null,
    error: false,
    errorMessage: null,
}

const actions = {
    validationFailed({ commit }, error) {
        commit('ERROR', error)
    },

    async requestToken({ commit }, { msisdn, access_token }) {
        const otpService = new SafaricomOTPService(access_token)

        commit('SET', { guid: null, timestamp: null })

        return otpService.prompt(msisdn)
            .then((response) => {
                if (response.status === 201) {
                    const { guid, timestamp } = response.data
                    commit('SET', { guid, timestamp })
                }
                return response
            })
            .catch((error) => error)
    },

    async validateToken({ commit }, { msisdn, otp, guid, timestamp, access_token }) {
        const otpService = new SafaricomOTPService(access_token)

        commit('SET', { guid: null, timestamp: null })

        return new Promise((resolve, reject) => {
            otpService.validate({ msisdn, otp, guid, timestamp })
                .then((response) => {
                    console.log(response)
                    return response.status === 204 ? resolve() : reject()
                })
                .catch((err) => reject(err))
        })
    },

    resetErrors({ commit }) {
        commit('ERROR', false)
    },

    reset({ commit }) {
        commit('SET', { guid: null, timestamp: null })
        commit('ERROR', false)
    },
}

const mutations = {
    SET(state, props) {
        const { guid, timestamp } = props

        Object.assign(state, { guid, timestamp })
    },
    ERROR(state, error) {
        state.error = error
    },
    LOG(state, res) {
        console.log(res)
    },
}

const getters = {
    params(state) {
        if (state.guid) {
            return {
                guid: state.guid,
                timestamp: state.timestamp,
            }
        }

        return false
    },
    error(state) {
        return state.error
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
